<template>
    <auth-box class="max-w-[480px]" :errors="props.errors">
        <form
            id="login-form"
            ref="formRef"
            method="POST"
            action="/login"
            class="flex flex-col gap-4"
            novalidate
            @submit.prevent="submit()"
        >
            <input name="remember" value="1" type="hidden" />
            <div>
                <vx-label> Email </vx-label>
                <vx-input
                    v-model="data.email"
                    type="email"
                    autofocus
                    name="email"
                    id="email"
                    size="lg"
                    data-test="email"
                    :error="v$.email.$error ? 'Email is invalid' : ''"
                >
                </vx-input>
            </div>
            <div>
                <vx-label> Password </vx-label>
                <vx-input
                    type="password"
                    v-model="data.password"
                    data-test="password"
                    autofocus
                    togglePassword
                    name="password"
                    id="password"
                    size="lg"
                    :error="v$.password.$error ? 'Password is invalid' : ''"
                ></vx-input>
                <a
                    class="flex items-center mt-2 underline text-slate-600 hover:text-slate-600 text-xs"
                    :href="`/password/reset?email=${encodeURIComponent(
                        data.email
                    )}`"
                >
                    <font-awesome-icon widthAuto
                        :icon="faCircleInfo"
                        class="mr-1"
                    ></font-awesome-icon>
                    Forgot Password?
                </a>
            </div>

            <div ref="recaptchaRef"></div>

            <div
                class="flex flex-col gap-2 mt-4 md:flex-row-reverse"
            >
                <vx-button
                    @click.prevent="submit()"
                    :loading="submitting"
                    data-test="submit"
                    class="md:grow"
                    type="submit"
                    color="primary"
                    size="lg"
                >
                    Log In
                    <font-awesome-icon widthAuto
                        :icon="faArrowRight"
                    ></font-awesome-icon>
                </vx-button>
                <vx-button color="muted" size="lg" href="/login/sso">
                    Use SSO
                    <font-awesome-icon widthAuto :icon="faArrowRight"></font-awesome-icon>
                </vx-button>
            </div>
        </form>
    </auth-box>
</template>
<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import AuthBox from "../AuthBox.vue";
import { VxLabel, VxInput, VxButton } from '@voxie/frontend-components';
import { faArrowRight, faCircleInfo } from "@fortawesome/pro-solid-svg-icons";
import { ref, reactive, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import { validateRules } from '~/utils/validation';
import { useRecaptcha } from '~/composables/useRecaptcha';

const props = defineProps({
    recaptchaKey: String,
    errors: Array,
    oldEmail: String,
});

const recaptcha = useRecaptcha(props.recaptchaKey ?? '');
const formRef = ref(null);
const recaptchaRef = ref(null);

onMounted(() => {
    if (recaptchaRef.value) {
        recaptcha.render(recaptchaRef.value);
    }
});

const data = reactive({
    email: props.oldEmail || "",
    password: "",
});

const submitting = ref(false);

const v$ = useVuelidate(
    {
        email: { required, email },
        password: { required },
    },
    data
);

const submit = async () => {
    submitting.value = true;

    const isFormCorrect = await validateRules(v$);
    if (!isFormCorrect) {
        submitting.value = false;
        return;
    }

    try {
        await recaptcha.execute();
    } catch {
        submitting.value = false;
        return;
    }

    formRef.value?.submit();
};

Object.keys(window.sessionStorage)
    .filter((key) => {
        return /displayedNotActiveTeam/.test(key);
    })
    .forEach((key) => {
        window.sessionStorage.removeItem(key);
    });
</script>
